import type { Comment, UserInputContext } from "../types"

function inlineCommentPayload(comment: Comment) {
    return {
        id: comment.id,
        source: comment.source,
        selectedText: comment.selectedText,
        comment: comment.content,
    }
}

export function withInlineComments(input: UserInputContext, comments: readonly Comment[]): UserInputContext {
    if (comments.length === 0) return input

    const commentBlock = ["<user_inline_comments>", JSON.stringify(comments.map(inlineCommentPayload), null, 2), "</user_inline_comments>"].join("\n")

    return {
        ...input,
        userInput: [input.userInput.trim(), commentBlock].filter(Boolean).join("\n\n"),
    }
}
